import { get, post } from './client';
import {
  isLinkedSubWalletConflict,
  linkedSubWalletAddresses,
  linkedSubWalletsFromConflict,
} from './kycWallets';

// `||` so an empty string counts as unset. A missing Actions secret is
// injected as "" and `??` would keep it, which skips this dev default.
const API_BASE_URL =
  process.env.REACT_APP_CHECKIN_API_URL || 'https://dev-api.checkin.degencoinflip.com/v1';

export { isLinkedSubWalletConflict, linkedSubWalletAddresses, linkedSubWalletsFromConflict };

export const getKycProfiles = async (Authorization = '') => {
  try {
    const response = await get(`${API_BASE_URL}/kyc-profiles`, { Authorization });
    console.log(response);
    return response.payload.profiles;
  } catch (error) {
    console.error('Error fetching KYC profiles:', error);
    throw error;
  }
};

// GET getAllWalletsByPrimaryWallet. Admin-readable via LEGAL_WALLETS.
// Route from the checkin-svc inventory: /kyc-profile/wallet/{primaryWalletId}/sub-wallets.
export const getLinkedKycSubWallets = async (primaryWalletId, Authorization = '') => {
  const response = await get(
    `${API_BASE_URL}/kyc-profile/wallet/${encodeURIComponent(primaryWalletId)}/sub-wallets`,
    { Authorization }
  );
  return linkedSubWalletAddresses(response, primaryWalletId);
};

// POST archiveKycPrimaryWallet. Body is only the two keys the handler accepts.
// archivedBy is stamped from the caller. dryRun is not sent.
export const archiveKycPrimaryWallet = async (
  walletId,
  { expectedKycProfileId, reason },
  Authorization = ''
) =>
  post(
    `${API_BASE_URL}/kyc-profile/admin/${encodeURIComponent(walletId)}/archive`,
    { expectedKycProfileId, reason },
    { Authorization }
  );
